import React, { useState, useEffect, useRef } from 'react';
import { faSquare } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ColumnDef } from '@tanstack/react-table';
import AdvanceTable from 'components/base/AdvanceTable';
import { currencyFormat, numberFormat } from 'helpers/utils';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import { Link } from 'react-router-dom';

import { useNavigate } from 'react-router-dom';
import { useAuth } from 'providers/AuthProvider'
import apiClient, { handleAPIError } from 'helpers/apiService';

export type AllReportsFoldersTableData = {
    contact_id: number | null;
    contact: string;
    sessions: number;
    feedbacks: number;
};

const columns: ColumnDef<AllReportsFoldersTableData>[] = [
    {
        header: 'Contacts',
        accessorFn: rowData => rowData.contact,
        cell: ({ row: { original } }) => {
            const { contact_id, contact } = original;
            return (
                <Link to={`/contacts/update-contact?contact_id=${contact_id}`} className="fw-semi-bold">
                    {contact}
                </Link>
            );
        },
        meta: {
            headerProps: {
                style: { width: '15%', minWidth: '100px' },
                className: 'text-start text-700'
            },
            cellProps: { className: 'pe-3 white-space-nowrap py-2' },
            footerProps: {
                className: 'text-end px-3 border-bottom-0'
            }
        }
    },
    {
        id: 'sessions',
        header: () => (
            <div className="d-inline-flex flex-center gap-2">
                <FontAwesomeIcon icon={faSquare} className="fs-11 text-primary" />
                Sessions
            </div>
        ),
        accessorKey: 'sessions',
        cell: ({ row: { original } }) => numberFormat(original.sessions),
        meta: {
            headerProps: {
                style: { width: '15%', minWidth: '95px' },
                className: 'text-end px-3 text-700'
            },
            cellProps: {
                className: 'text-end fw-semi-bold text-900 py-2 px-3'
            },
            footerProps: {
                className: 'text-end px-3 border-bottom-0'
            }
        }
    },
    {
        id: 'feedbacks',
        header: () => (
            <div className="d-inline-flex flex-center gap-2">
                <FontAwesomeIcon icon={faSquare} className="fs-11 text-primary-300" />
                Feedbacks
            </div>
        ),
        accessorKey: 'feedbacks',
        cell: ({ row: { original } }) => numberFormat(original.feedbacks),
        meta: {
            headerProps: {
                style: { width: '20%', minWidth: '100px' },
                className: 'text-end px-3 text-700'
            },
            cellProps: {
                className: 'text-end fw-semi-bold text-900 py-2 px-3'
            },
            footerProps: {
                className: 'text-end px-3 py-2 border-bottom-0'
            }
        }
    }
];

const AllReportsFoldersTable = () => {

    const auth = useAuth();
    const [reports, setReports] = useState<AllReportsFoldersTableData[]>([]);

    const table = useAdvanceTable({
        data: reports,
        columns,
        pageSize: 5,
        pagination: true,
        selectionColumnWidth: '30px',
        sortable: true
    });


    const fetchData = async () => {
        try {
            const response = await apiClient.get(
                '/v1/myskills/allreportsfolders',
                {
                    headers: {
                        'accept': 'application/json',

                    },
                    withCredentials: true,
                }
            );
            setReports(response.data);
        } catch (error) {
            console.error('Request failed:', error);
        }
    };

    useEffect(() => {
        console.log("useEffect");
        fetchData();
    }, []);

    return (
        <AdvanceTableProvider {...table}>
            <AdvanceTable
                hasFooter
                tableProps={{
                    size: 'sm',
                    className:
                        'phoenix-table phoenix-table-bordered fs-9 mb-0 border-top border-300'
                }}
            />
        </AdvanceTableProvider>
    );
};

export default AllReportsFoldersTable;
